import { IKindResultDecision } from 'APIPackage/CatalogsModule/interfaces/IKindResultDecision';

import { IErknmKindResultDecisionSelectOption } from '../interfaces/IErknmKindResultDecisionSelectOption';

export const createKindResultDecisionSelectOption = (
  erknmKindResultDecision: IKindResultDecision,
): IErknmKindResultDecisionSelectOption => ({
  ...erknmKindResultDecision,
  label: erknmKindResultDecision.name,
  value: erknmKindResultDecision.code,
});
